<script>
  import { Popover } from 'bootstrap';
  import TaskList from './TaskDashboard/TaskList.svelte';
  import TaskOutlook from './TaskDashboard/TaskOutlook.svelte';
  import TaskScheduled from './TaskDashboard/TaskScheduled.svelte';
  import DropDown from './DropDown.svelte';
  export let dashboardLeftObj;
  import { onMount, onDestroy } from 'svelte';
  import { client } from 'root/api/index.js';
  import { masterData, getMasterData } from '../stores/masterData.js';
  import {
    dashboardData,
    getDashboardData,
    setDashboardData,
    resetDashboardData,
  } from '../stores/dashboard.js';
  import { getHashUrlParam, configItem, cloneArray, getURLParameters } from 'components/Helper.js';
  import ClientsDetailModal from '../components/clients/ClientsDetailModal.svelte';
  import { checkRole } from '../stores/auth.js';
  import { searchKeyByValue } from 'components/Helper.js';
  const showClientModal = (clientId, clientFundProfileId) => {
    clientDetailModal.showModal({
      id: clientId,
      clientFundProfileId,
    });
  };

  let tabIndex = 0;
  let units;
  let tabLoad;
  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        units = cloneArray(getMasterData().units);
      }
    });
  });

  const dashboardUnsubscribe = dashboardData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined && units) {
        units = units.map((item) => {
          item.checked = searchKeyByValue(state.units, 'id', item.id) != -1;
          return item;
        });
        isManagerChecked = state.isManager == 1;
      }
    });
  });

  const handleFilter = async () => {
    const { tab } = getURLParameters();
    if (configItem.taskTabIndex[tab]) {
      tabIndex = configItem.taskTabIndex[tab];
    }
    tabLoad = true;
  };

  onDestroy(() => {
    unsubscribe();
    dashboardUnsubscribe();
    // resetDashboardData()
  });
  let isManagerChecked = false;
  const checkUrl = () => {
    setTimeout(() => {
      let params = getHashUrlParam();
      if (params.action != undefined) {
        if (params.action == 'openTask') {
          tabIndex = 0;
          setTimeout(() => {
            objCurrentList.checkUrl(params);
          }, 1000);
        } else if (params.action == 'scheduleTask') {
          tabIndex = 1;
          setTimeout(() => {
            objCurrentList.checkUrl(params);
          }, 1000);
        } else if (params.action == 'taskOutlook') {
          tabIndex = 2;
          setTimeout(() => {
            let oldUnit = units;
            oldUnit.map((item) => {
              item.checked = params.unitId == item.id;
              return item;
            });
            units = oldUnit;
            objCurrentList.checkUrl(params);
          }, 1000);
        } else if (params.action == 'managerTask') {
          setTimeout(() => {
            isManagerChecked = true;
            setDashboardData({
              ...getDashboardData(),
              isManager: 1,
            });
          }, 1000);
        } else {
          let dasaboardData = { ...getDashboardData() };
          if (params.unitId != undefined) {
            dasaboardData.units = [{ id: params.unitId, unitId: params.unitId }];
          }
          if (params.clientId != undefined) {
            dasaboardData.clients = [{ id: params.clientId }];
          }
          setDashboardData(dasaboardData);
          setTimeout(() => {
            objCurrentList.checkUrl(params);
          }, 1000);
        }
        setTimeout(() => {
          dashboardLeftObj.checkUrl(params);
          window.location.hash = '';
        }, 1500);
      }
    }, 500);
  };
  let objCurrentList;
  onMount(() => {
    checkUrl();
    var elements = document.querySelectorAll('.tasklist-popover');
    elements.forEach(function (el) {
      new Popover(el, { container: el.parentElement });
    });
    setDashboardData({ ...getDashboardData(), isManager: 0 });
    handleFilter();
  });
  let unitDropdown;
  let taskFilter = {};
  let scheduleFilter = {};
  const setDashboardFilter = (flag, filter) => {
    // if(flag=="task"){
    //   taskFilter=filter
    // }else{
    //   scheduleFilter=filter
    // }
    showConfirm = true;
  };
  let showConfirm = false;
  let clientDetailModal;
</script>

<div class="d-flex h-100 w-100 p-3 flex-column">
  <div class="block-header mb-2">
    <div class="row align-items-center">
      <div class="col-md-7">
        <div class="d-flex flex-row align-items-center">
          <h2 class="page-title me-3">Task Dashboard</h2>

          <div class="dropdown btn-drop-down position-relative me-3">
            <DropDown
              showConfirm={showConfirm}
              confirmMessage="Applying this filter will reset all currently applied filters."
              checkbox={true}
              active={true}
              title="Business Unit"
              labelFields="name"
              keyFields="id"
              option={units}
              checkedFields="checked"
              Style="select-block font-size-13 w-100"
              on:onSelect={(event) => {
                if (showConfirm) {
                  setDashboardData({
                    ...getDashboardData(),
                    units: event.detail,
                    taskServiceType: [],
                    taskActivityTypes: [],
                    clients: [],
                    users: [],
                    fromDate: '',
                    toDate: '',
                  });
                } else {
                  setDashboardData({
                    ...getDashboardData(),
                    units: event.detail,
                    taskServiceType: [],
                    taskActivityTypes: [],
                  });
                }
                showConfirm = false;
              }}
            />
          </div>
          {#if checkRole(configItem.roleIndex.user) == false}
            <div class="d-flex flex-row align-items-center">
              <label
                for=""
                class="text-nowrap mb-0 me-2">Manager View</label
              >
              <div class="form-check form-switch custom-switch">
                <input
                  class="form-check-input shadow-none"
                  type="checkbox"
                  checked={isManagerChecked}
                  on:change={(event) => {
                    setDashboardData({
                      ...getDashboardData(),
                      isManager: event.target.checked ? 1 : 0,
                    });
                  }}
                />
              </div>
            </div>
          {/if}

          {#if tabIndex == 0 || tabIndex == 1}
            <button
              type="button"
              on:click={() => objCurrentList.addTask()}
              style="margin-left:20px;    padding: 5px 10px;"
              class="mb-0px-3 font-size-13 add-task-btn task-add-btn">Create Task</button
            >
          {/if}
        </div>
      </div>

      <div class="col-md-5 text-right">
        <div class="d-flex flex-row justify-content-end">
          <div
            class="btn-group w-100 common-btn-group me-1"
            role="group"
          >
            <button
              on:click={() => {
                if (tabIndex != 0) {
                  showConfirm = false;
                }
                tabIndex = 0;
                dashboardLeftObj.setTabIndex(1);
              }}
              type="button"
              class="btn btn-primary position-relative mb-0 popover rounded shadow-none button-group {tabIndex ==
              0
                ? 'active'
                : null}"
            >
              <svg
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                viewBox="0 0 438.891 438.891"
                style="enable-background:new 0 0 438.891 438.891;"
                xml:space="preserve"
              >
                <g
                  ><g
                    ><g
                      ><path
                        d="M347.968,57.503h-39.706V39.74c0-5.747-6.269-8.359-12.016-8.359h-30.824c-7.314-20.898-25.6-31.347-46.498-31.347                         c-20.668-0.777-39.467,11.896-46.498,31.347h-30.302c-5.747,0-11.494,2.612-11.494,8.359v17.763H90.923                         c-23.53,0.251-42.78,18.813-43.886,42.318v299.363c0,22.988,20.898,39.706,43.886,39.706h257.045                         c22.988,0,43.886-16.718,43.886-39.706V99.822C390.748,76.316,371.498,57.754,347.968,57.503z                         M151.527,52.279h28.735                         c5.016-0.612,9.045-4.428,9.927-9.404c3.094-13.474,14.915-23.146,28.735-23.51c13.692,0.415,25.335,10.117,28.212,23.51                         c0.937,5.148,5.232,9.013,10.449,9.404h29.78v41.796H151.527V52.279z                         M370.956,399.185c0,11.494-11.494,18.808-22.988,18.808                        H90.923c-11.494,0-22.988-7.314-22.988-18.808V99.822c1.066-11.964,10.978-21.201,22.988-21.42h39.706v26.645                        c0.552,5.854,5.622,10.233,11.494,9.927h154.122c5.98,0.327,11.209-3.992,12.016-9.927V78.401h39.706                         c12.009,0.22,21.922,9.456,22.988,21.42V399.185z"
                      />
                      <path
                        d="M179.217,233.569c-3.919-4.131-10.425-4.364-14.629-0.522l-33.437,31.869l-14.106-14.629                          c-3.919-4.131-10.425-4.363-14.629-0.522c-4.047,4.24-4.047,10.911,0,15.151l21.42,21.943c1.854,2.076,4.532,3.224,7.314,3.135                         c2.756-0.039,5.385-1.166,7.314-3.135l40.751-38.661c4.04-3.706,4.31-9.986,0.603-14.025                         C179.628,233.962,179.427,233.761,179.217,233.569z"
                      />
                      <path
                        d="M329.16,256.034H208.997c-5.771,0-10.449,4.678-10.449,10.449s4.678,10.449,10.449,10.449H329.16                          c5.771,0,10.449-4.678,10.449-10.449S334.931,256.034,329.16,256.034z"
                      />
                      <path
                        d="M179.217,149.977c-3.919-4.131-10.425-4.364-14.629-0.522l-33.437,31.869l-14.106-14.629                          c-3.919-4.131-10.425-4.364-14.629-0.522c-4.047,4.24-4.047,10.911,0,15.151l21.42,21.943c1.854,2.076,4.532,3.224,7.314,3.135                         c2.756-0.039,5.385-1.166,7.314-3.135l40.751-38.661c4.04-3.706,4.31-9.986,0.603-14.025                         C179.628,150.37,179.427,150.169,179.217,149.977z"
                      />
                      <path
                        d="M329.16,172.442H208.997c-5.771,0-10.449,4.678-10.449,10.449s4.678,10.449,10.449,10.449H329.16                          c5.771,0,10.449-4.678,10.449-10.449S334.931,172.442,329.16,172.442z"
                      />
                      <path
                        d="M179.217,317.16c-3.919-4.131-10.425-4.363-14.629-0.522l-33.437,31.869l-14.106-14.629                          c-3.919-4.131-10.425-4.363-14.629-0.522c-4.047,4.24-4.047,10.911,0,15.151l21.42,21.943c1.854,2.076,4.532,3.224,7.314,3.135                          c2.756-0.039,5.385-1.166,7.314-3.135l40.751-38.661c4.04-3.706,4.31-9.986,0.603-14.025                          C179.628,317.554,179.427,317.353,179.217,317.16z"
                      />
                      <path
                        d="M329.16,339.626H208.997c-5.771,0-10.449,4.678-10.449,10.449s4.678,10.449,10.449,10.449H329.16                          c5.771,0,10.449-4.678,10.449-10.449S334.931,339.626,329.16,339.626z"
                      />
                    </g>
                  </g>
                </g> <g /> <g />
              </svg>
              Task List
              <button
                class="m-0 p-0 info-icons position-absolute tasklist-popover"
                data-bs-placement="bottom"
                data-bs-toggle="popover"
                data-bs-trigger="focus"
                data-bs-content="This shows all actionable or completed tasks based on flters selected - you can show tasks by client, by assignee, by status, etc"
              >
                <img
                  class=" icon-14"
                  alt=""
                  src="/images/info.svg"
                />
              </button>
            </button>
            <button
              type="button"
              class="btn btn-primary mb-0 shadow-none scheduled-btn popover position-relative rounded button-group {tabIndex ==
              1
                ? 'active'
                : null}"
              on:click={() => {
                if (tabIndex != 1) {
                  showConfirm = false;
                }
                dashboardLeftObj.setTabIndex(0);
                tabIndex = 1;
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64"
                width="512"
                height="512"
                ><g id="Calendar"
                  ><path
                    d="M57,8H52V6a4,4,0,0,0-8,0V8H36V6a4,4,0,0,0-8,0V8H20V6a4,4,0,0,0-8,0V8H7a5,5,0,0,0-5,5V53a5,5,0,0,0,5,5H35a1,1,0,0,0,0-2H7a3.009,3.009,0,0,1-3-3V22H60V39a1,1,0,0,0,2,0V13A5,5,0,0,0,57,8ZM46,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM30,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM14,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM60,20H4V13a3.009,3.009,0,0,1,3-3h5v2a4,4,0,0,0,8,0V10h8v2a4,4,0,0,0,8,0V10h8v2a4,4,0,0,0,8,0V10h5a3.009,3.009,0,0,1,3,3Z"
                  /><path
                    d="M30,29a2,2,0,0,0-2-2H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V29h4v3Z"
                  /><path
                    d="M18,29a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V29h4v3Z"
                  /><path
                    d="M52,34a2,2,0,0,0,2-2V29a2,2,0,0,0-2-2H48a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2Zm-4-5h4v3H48Z"
                  /><path
                    d="M30,38a2,2,0,0,0-2-2H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V38h4v3Z"
                  /><path
                    d="M18,38a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V38h4v3Z"
                  /><path
                    d="M28,45H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V47A2,2,0,0,0,28,45Zm-4,5V47h4v3Z"
                  /><path
                    d="M36,34h4a2,2,0,0,0,2-2V29a2,2,0,0,0-2-2H36a2,2,0,0,0-2,2v3A2,2,0,0,0,36,34Zm0-5h4v3H36Z"
                  /><path
                    d="M34,41a2,2,0,0,0,2,2,1,1,0,0,0,0-2V38h4a1,1,0,0,0,0-2H36a2,2,0,0,0-2,2Z"
                  /><path
                    d="M16,45H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V47A2,2,0,0,0,16,45Zm-4,5V47h4v3Z"
                  /><path
                    d="M49,36A13,13,0,1,0,62,49,13.015,13.015,0,0,0,49,36Zm0,24A11,11,0,1,1,60,49,11.013,11.013,0,0,1,49,60Z"
                  /><path
                    d="M54.778,44.808,47,52.586,43.465,49.05a1,1,0,0,0-1.414,1.414l4.242,4.243a1,1,0,0,0,1.414,0l8.485-8.485a1,1,0,0,0-1.414-1.414Z"
                  /></g
                ></svg
              >
              Scheduled

              <button
                class="m-0 p-0 info-icons position-absolute tasklist-popover"
                data-bs-placement="bottom"
                data-bs-toggle="popover"
                data-bs-trigger="focus"
                data-bs-content="These are all of the tasks that have been scheduled based on the filter selected."
              >
                <img
                  class=" icon-14"
                  alt=""
                  src="/images/info.svg"
                />
              </button>
            </button>
            <button
              type="button"
              class="btn btn-primary shadow-none mb-0 popover rounded button-group {tabIndex == 2
                ? 'active'
                : null}"
              on:click={() => {
                if (tabIndex != 2) {
                  showConfirm = false;
                }
                dashboardLeftObj.setTabIndex(1);
                tabIndex = 2;
              }}
            >
              <svg
                id="Layer_2"
                enable-background="new 0 0 24 24"
                height="512"
                viewBox="0 0 24 24"
                width="512"
                xmlns="http://www.w3.org/2000/svg"
                ><g
                  ><path
                    d="m3.5 7h-2c-.827 0-1.5-.673-1.5-1.5v-2c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5v2c0 .827-.673 1.5-1.5 1.5zm-2-4c-.275 0-.5.225-.5.5v2c0 .275.225.5.5.5h2c.275 0 .5-.225.5-.5v-2c0-.275-.225-.5-.5-.5z"
                  /></g
                ><g
                  ><path
                    d="m3.5 15h-2c-.827 0-1.5-.673-1.5-1.5v-2c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5v2c0 .827-.673 1.5-1.5 1.5zm-2-4c-.275 0-.5.225-.5.5v2c0 .275.225.5.5.5h2c.275 0 .5-.225.5-.5v-2c0-.275-.225-.5-.5-.5z"
                  /></g
                ><g
                  ><path
                    d="m3.5 23h-2c-.827 0-1.5-.673-1.5-1.5v-2c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5v2c0 .827-.673 1.5-1.5 1.5zm-2-4c-.275 0-.5.225-.5.5v2c0 .275.225.5.5.5h2c.275 0 .5-.225.5-.5v-2c0-.275-.225-.5-.5-.5z"
                  /></g
                ><g
                  ><path
                    d="m23.5 5h-16c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h16c.276 0 .5.224.5.5s-.224.5-.5.5z"
                  /></g
                ><g
                  ><path
                    d="m23.5 13h-16c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h16c.276 0 .5.224.5.5s-.224.5-.5.5z"
                  /></g
                ><g
                  ><path
                    d="m23.5 21h-16c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h16c.276 0 .5.224.5.5s-.224.5-.5.5z"
                  /></g
                ></svg
              >
              Task Outlook

              <button
                class="m-0 p-0 info-icons position-absolute tasklist-popover"
                data-bs-placement="bottom"
                data-bs-toggle="popover"
                data-bs-trigger="focus"
                data-bs-content="These are all of the tasks that have been scheduled listed out by date they are set to occur or occurred in the past for the time period selected."
              >
                <img
                  class=" icon-14"
                  alt=""
                  src="/images/info.svg"
                />
              </button>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  {#if tabLoad}
    <div class="page-content card-content bg-white overflow-hidden">
      <div class="d-flex flex-column h-100">
        <!-- Task List -->
        {#if tabIndex == 0}
          <TaskList
            bind:this={objCurrentList}
            setDashboardFilter={setDashboardFilter}
            showClientModal={showClientModal}
            dashboardLeftObj={dashboardLeftObj}
          />
        {:else if tabIndex == 1}
          <TaskScheduled
            bind:this={objCurrentList}
            showClientModal={showClientModal}
            setDashboardFilter={setDashboardFilter}
            dashboardLeftObj={dashboardLeftObj}
          />
        {:else if tabIndex == 2}
          <TaskOutlook
            bind:this={objCurrentList}
            showClientModal={showClientModal}
            setDashboardFilter={setDashboardFilter}
            dashboardLeftObj={dashboardLeftObj}
          />
        {/if}
        <!-- Task List End-->
      </div>
    </div>
  {/if}
</div>
<ClientsDetailModal bind:this={clientDetailModal} />

<style lang="scss">
  .scheduled-btn {
    margin: 0 4px !important;
  }
  .info-icons {
    right: 10px;
  }
  .custom-switch {
    input {
      width: 52px;
      height: 27px;
    }
  }
</style>
